export default "__VITE_ASSET__BJJSM4hL__"